module.exports = __webpack_public_path__ + "static/media/20201114_121445_523_IMG_9943.c51d9779.jpg";